import { createBrowserRouter } from "react-router-dom";
import App from "../App";
import Dashboard from "../pages/Dashboard";
import Bhavan from "../pages/Bhavan";
import BhavanDetails from "../pages/BhavanDetails";
import WaterTank from "../pages/WaterTank";
import WaterTankDetails from "../pages/WaterTankDetails";
import Sanitary from "../pages/Sanitary";
import SanitaryDetails from "../pages/SanitaryDetails";
import ParkTicket from "../pages/ParkTicket";
import ParkTicketDetails from "../pages/ParkTicketDetails";
import PropertyTax from "../pages/PropertyTax";
import Licence from "../pages/Licence";
import LicenceReportDetails from "../pages/LicenceReportDetails";
import CarReport from "../pages/CarReport";
import Attendence from "../pages/Attendence";
import AttendenceReport from "../pages/AttendenceReport";
import PWD from "../pages/Pwd";
import PdfSection from "../pages/Pdfsection";
import ChairmanLogin from "../pages/Chairman_Login";
import DepartmentLogin from "../pages/Department_Login";
import AdminLogin from "../pages/AdminLogin";
import AdminDashboard from "../pages/AdminDashboard";
import FinanceAccountUsers from "../pages/FinnnanceAccountUsers";
import SuperAdminProtectedRoute from "../components/SuperAdminProtectedRoute";
import Login from "../pages/SuperAdmin/Login";
import SuperAdminDashboard from "../pages/SuperAdmin/SuperAdminDashboard";
import FundManagement from "../pages/SuperAdmin/FundManagement";
import DepartmentManagement from "../pages/SuperAdmin/DepartmentManagement";
import Usermanagment from "../pages/SuperAdmin/Usermanagment";
import SADepartmentLogin from "../pages/SuperAdmin/DepertmentLogin";
import DepartmentDashboard from "../pages/SuperAdmin/DepartmentDashbord";
import DepartmentProtectedRoute from "../components/DepartmentProtectedRoute";
import PWDReportList from "../pages/SuperAdmin/pwdreportlist";
import FundList from "../pages/SuperAdmin/fundlist";
import Fundmanagement from "../pages/Fundmanagement";
import Expessense from "../pages/SuperAdmin/Expessense";
import CreateTradeLicense from "../pages/TradeLicense/CreateTradeLicense";
import TradeLicenseList from "../pages/TradeLicense/TradeLicenseList";
import AddAdvertisement from "../pages/SuperAdmin/AddAdvertisement";
import UpdateTradeLicense from "../pages/TradeLicense/UpdateTradeLicense";
import AdvertisementList from "../Advertisement/AdvertisementList";
import TradeTypes from "./../pages/SuperAdmin/components/TradeTypes";
import TradeLicenseHistory from "../pages/TradeLicense/TradeLicenseHistory";
import PaymentReports from "../pages/PaymentReports";
import SanitaryReportList from "../pages/Sanitary/SanitaryReportList";
import HfaList from "../pages/HFA/HfaList";
import AddHfaBeneficiary from "../pages/HFA/AddHfaBeneficiary";
import EditHfaBeneficiary from "../pages/HFA/EditHfaBeneficiary";
import HFA from "../pages/HFA";
import MaaCanteenReport from "../pages/MaaCanteenReport";
import MaaCanteenDetails from "../pages/MaaCanteenDetails";
import TradeLicenseHistoryChairman from "../pages/TradeLicenseHistoryChairman";
import MarketData from "../pages/Market/MarketData";
import RoomRent from "../pages/Market/RoomRent";
import TaxCollectorList from "../pages/TaxCollector/TaxCollectorList";
import Market from "../pages/Market";
import TruckTerminus from "../pages/TruckTerminus";
import CashCategory from "../pages/SuperAdmin/cashcategory";
import CashSubCatagory from "../pages/SuperAdmin/cashsubcatagory";
import CashDailyChalan from "../pages/SuperAdmin/CashDailyChalan";
import ChalanList from "../pages/SuperAdmin/ChalanList";

const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
    children: [
      {
        path: "/",
        element: <ChairmanLogin />,
      },
      {
        path: "/dashboard",
        element: <Dashboard />,
      },
      {
        path: "/bhavan",
        element: <Bhavan />,
      },
      {
        path: "/bhavandetails/:bhavanId/:bhavanName",
        element: <BhavanDetails />,
      },
      {
        path: "/water-tank",
        element: <WaterTank />,
      },
      {
        path: "/water-tank/:serviceId/:serviceName",
        element: <WaterTankDetails />,
      },
      {
        path: "/sanitary",
        element: <Sanitary />,
      },
      {
        path: "/sanitarydetails/:sanitaryId/:sanitaryName",
        element: <SanitaryDetails />,
      },
      {
        path: "/park-ticket",
        element: <ParkTicket />,
      },
      {
        path: "/maa-canteen-report",
        element: <MaaCanteenReport />,
      },
      {
        path: "/canteendetails/:id/:created_by/:name",
        element: <MaaCanteenDetails />,
      },
      {
        path: "/park-ticket-details/:parkId/:parkName",
        element: <ParkTicketDetails />,
      },
      {
        path: "/property-tax",
        element: <PropertyTax />,
      },
      {
        path: "/licence",
        element: <Licence />,
      },
      {
        path: "/trade-license-history/:id",
        element: <TradeLicenseHistoryChairman />,
      },
      {
        path: "/licence/report/:reportName",
        element: <LicenceReportDetails />,
      },
      {
        path: "/car-report",
        element: <CarReport />,
      },
      {
        path: "/attendence",
        element: <Attendence />,
      },
      {
        path: "/attendence/report/:section",
        element: <AttendenceReport />,
      },
      {
        path: "/hfa",
        element: <HFA />,
      },
      {
        path: "/pwd",
        element: <PWD />,
      },
      {
        path: "/fund-management",
        element: <Fundmanagement />,
      },
      {
        path: "/market",
        element: <Market />,
      },
      {
        path: "/truck_terminus",
        element: <TruckTerminus/>
      },
      {
        path: "/departmentlogin",
        element: <DepartmentLogin />,
      },
      {
        path: "/pwdsection",
        element: <PdfSection />,
      },
      {
        path: "/adminlogin",
        element: <AdminLogin />,
      },
      {
        path: "/admin-dashboard",
        element: <AdminDashboard />,
      },
      {
        path: "/admin/finnnance-accounts-users",
        element: <FinanceAccountUsers />,
      },
      {
        path: "/superadmin",
        element: <Login />,
      },
      {
        element: <SuperAdminProtectedRoute />,
        children: [
          {
            path: "/SuperAdminDashboard",
            element: <SuperAdminDashboard />,
          },
          {
            path: "/superadmin/fund-management",
            element: <FundManagement />,
          },
          {
            path: "/superadmin/department-management",
            element: <DepartmentManagement />,
          },
          {
            path: "/superadmin/user-management",
            element: <Usermanagment />,
          },
          {
            path: "superadmin/trade-types",
            element: <TradeTypes />,
          },
          {
            path: "/superadmin/pwdreportlist",
            element: <PWDReportList />,
          },
        ],
      },
      {
        path: "/department",
        element: <SADepartmentLogin />,
      },
      {
        element: <DepartmentProtectedRoute />,
        children: [
          {
            path: "/departmentDashbord",
            element: <DepartmentDashboard />,
          },
          {
            path: "/departmentDashboard/pwdreportlist",
            element: <PWDReportList />,
          },
          {
            path: "/departmentDashboard/trade-license-list",
            element: <TradeLicenseList />,
          },
          {
            path: "/departmentDashboard/fundlist",
            element: <FundList />,
          },
          {
            path: "/departmentDashboard/expessense",
            element: <Expessense />,
          },
          {
            path: "/departmentDashboard/chalan-list",
            element: <ChalanList />,
          },
          {
            path: "/departmentDashboard/cashcategory",
            element: <CashCategory />,
          },
          {
            path: "/departmentDashboard/cashsubcatagory",
            element: <CashSubCatagory />,
          },
          {
            path: "/departmentDashboard/cash-daily-chalan",
            element: <CashDailyChalan />,
          },
          {
            path: "departmentDashboard/create-trade-license",
            element: <CreateTradeLicense />,
          },
          {
            path: "departmentDashboard/update-trade-license/:id",
            element: <UpdateTradeLicense />,
          },
          {
            path: "departmentDashboard/add-advertisement",
            element: <AddAdvertisement />,
          },
          {
            path: "departmentDashboard/advertisement-list",
            element: <AdvertisementList />,
          },
          {
            path: "departmentDashboard/update-advertisement",
            element: <AdvertisementList />,
          },
          {
            path: "departmentDashboard/trade-license-history/:id",
            element: <TradeLicenseHistory />,
          },
          {
            path: "departmentDashboard/reports",
            element: <PaymentReports />,
          },
          {
            path: "departmentDashboard/sanitary",
            element: <Sanitary />,
          },
          {
            path: "departmentDashboard/sanitarydetails/:sanitaryId/:sanitaryName",
            element: <SanitaryDetails />,
          },
          {
            path: "departmentDashboard/water-tank",
            element: <WaterTank />,
          },

          {
            path: "departmentDashboard/water-tank/:serviceId/:serviceName",
            element: <WaterTankDetails />,
          },
          {
            path: "departmentDashboard/sanitary-work-order",
            element: <SanitaryReportList />,
          },
          {
            path: "departmentDashboard/hfa-beneficiary-list",
            element: <HfaList />,
          },
          {
            path: "departmentDashboard/add-hfa-beneficiary",
            element: <AddHfaBeneficiary />,
          },
          {
            path: "departmentDashboard/edit-hfa-beneficiary/:id",
            element: <EditHfaBeneficiary />,
          },
          {
            path: "departmentDashboard/market-data",
            element: <MarketData />,
          },
          {
            path: "departmentDashboard/room-rent",
            element: <RoomRent />,
          },
          {
            path: "departmentDashboard/tax-collection",
            element: <TaxCollectorList />,
          },
        ],
      },
    ],
  },
]);

export default router;
